// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as SupSection from "./SupSection.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

var sizeFull = "892";

function SupTacticians(Props) {
  ScreenAtom.use(undefined);
  return React.createElement(React.Fragment, undefined, React.createElement(SupSection.make, {
                  children: null,
                  id: "set-update-tacticians",
                  title: "Tacticians"
                }, React.createElement(ContentSection.make, {
                      className: "",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Chibi SalaryMan Aatrox"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/chibi_aatrox_salaryman.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Chibi Soulfighter Jinx"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/soulfighter_jinx.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Spirit Blossom Springs Aphelios Unbound"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/unbound_aphelios_spiritblossomsprings.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Coven Leblanc Unbound"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/unbound_leblanc_coven.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Divine Brilliance Pengu"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/divine_brilliance_pengu.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Watermelon Puffin"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/watermelon_puffin.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    }), React.createElement(ContentSection.make, {
                      className: "mt-8",
                      children: React.createElement("div", undefined, React.createElement("h3", {
                                className: "text-2xl text-center font-montserrat font-medium pl-2 pb-4"
                              }, "Mushroom Sprite"), React.createElement("div", {
                                className: "flex flex-col md:flex-row gap-6"
                              }, React.createElement("img", {
                                    className: "rounded w-[320px] sm:w-[430px] md:w-[892px] ",
                                    height: sizeFull,
                                    src: "https://ap.tft.tools/img/gg17/mushroom_sprite.png?w=" + sizeFull,
                                    width: sizeFull
                                  })))
                    })));
}

var size = "152";

var size2 = "320";

var size2h = "180";

var arenaWidth = "768";

var arenaHeight = "432";

var sizeHalf = "430";

var sizeEmote = "320";

var make = SupTacticians;

export {
  size ,
  size2 ,
  size2h ,
  arenaWidth ,
  arenaHeight ,
  sizeHalf ,
  sizeFull ,
  sizeEmote ,
  make ,
  
}
/* react Not a pure module */
